import roadmap from "../data/roadmap.json";
import "../App.css";

export default function WhatsNew() {

  // ✅ Sort roadmap items by status
  const STATUS_ORDER = {
    "in-progress": 0,
    planned: 1,
    released: 2
  };

  const mainRoadmapItems = [...roadmap.roadmap.items].sort((a, b) => {
    const statusA = a.status ?? "planned";
    const statusB = b.status ?? "planned";
    return STATUS_ORDER[statusA] - STATUS_ORDER[statusB];
  });

  // ✅ Render status badge
  const renderBadge = (statusRaw) => {
    const status = statusRaw ?? "planned";
    return (
      <span className={`badge ${status}`}>
        {status.replace("-", " ")}
      </span>
    );
  };

  return (
    <div className="App">

      {/* -------------------- RELEASED -------------------- */}
      <section className="section">
        <h2>✅ Recently released</h2>

        {roadmap.released.map((item) => (
          <div key={item.version} className="release-card">
            <div className="release-header">
              <span className="version">v{item.version}</span>
              <span className="date">{item.date}</span>
            </div>
            <h3>{item.title}</h3>
            <p>{item.description}</p>
          </div>
        ))}
      </section>

      {/* -------------------- ROADMAP -------------------- */}
      <section className="section">
        <h2>🚧 Roadmap</h2>

        <ul className="roadmap-list">
          {mainRoadmapItems.map((item, i) => (
            <li key={i}>
              <strong>
                {item.title}
                {renderBadge(item.status)}
              </strong>
              <p>{item.description}</p>
            </li>
          ))}
        </ul>
      </section>

      {/* -------------------- FUTURE IDEAS -------------------- */}
      <section className="section">
        <h2>💭 Future ideas (may never happen)</h2>

        <ul className="roadmap-list">
          {roadmap.roadmap.futureIdeas.map((item, i) => (
            <li key={i}>
              <strong>
                {item.title}
                {item.title}
                {renderBadge(item.status)}
              </strong>
              <p>{item.description}</p>
            </li>
          ))}
        </ul>
      </section>

    </div>
  );
}
